import store from "../../../redux/store";
import { getSessionId } from "../../../helper/auth-helper";
import { TenantStorage } from "../../../helper/tenant-storage";

export function insertGoogleTag(tagId?: string) {
  if (!tagId) {
    console.error("Google Analytics not configurated for current environment");
    return;
  }
  const srcGTag = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
  if (!document.querySelector(`script[src="${srcGTag}"]`)) {
    const script = document.createElement("script");
    script.setAttribute("src", srcGTag);
    script.async = true;
    document.head.appendChild(script);
  }
  if (!document.querySelector(`script[id="google-tag-manager-script"]`)) {
    const script = document.createElement("script");
    script.setAttribute("id", "google-tag-manager-script");
    script.text = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${tagId}');`;
    document.head.appendChild(script);
  }
}

export function addGoogleAnalyticsEvent(eventName: string, eventParameters: object) {
  if (!(window as any)?.gtag) {
    console.error("Google Analytics not detected");
    return;
  }
  const reduxState = store?.getState();
  const tenant = reduxState?.tenant?.selectedTenant;
  const currentRoute = reduxState?.navigation?.currentRoute;
  const tenantStorage = new TenantStorage();
  const storedTenant = tenantStorage.getTenant();
  const tenatStore = reduxState?.tenant;
  const tenants = tenatStore?.tenants;
  const tenantIndex = tenants?.findIndex((_tenant: any) => _tenant.alias === tenant?.alias);
  (window as any)?.gtag("event", eventName, {
    app_name: "Connect",
    app_module: currentRoute?.section ?? "",
    tenant_name: tenant?.name || storedTenant?.name || tenants?.[tenantIndex]?.name || tenant?.alias || storedTenant?.alias,
    user_session_id: getSessionId(),
    ...eventParameters,
  });
}
